import { render, staticRenderFns } from "./WebrtcManager.vue?vue&type=template&id=9a012268"
import script from "./WebrtcManager.vue?vue&type=script&lang=js"
export * from "./WebrtcManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports